import React, {useEffect, useImperativeHandle, forwardRef, useRef, useContext} from 'react';
import Map from '../map';

const Context = React.createContext({});
const Provider = Context.Provider;

const Item = forwardRef((props, ref) => {
    const {children, wrapStyle, createdMap: createdMapProps, ...otherVal} = props;

    const dom = useRef();
    const mapRef = useRef();

    const {addMap, removeMap} = useContext(Context);

    // 移除地图
    useEffect(() => {
        return () => {
            removeMap(mapRef.current);
        }
    }, [])

    // 暴露给父组件
    useImperativeHandle(ref, () => ({
        dom: dom.current,
        mapRef: mapRef.current,
    }));

    // 创建地图
    const createdMap = (map) => {
        mapRef.current = map;

        createdMapProps?.(map);

        addMap(map);
    }
    return (
        <div ref={dom} style={{flex: 1, overflow: "hidden", border: '1px solid #ccc', ...wrapStyle}}>
            <Map {...otherVal} createdMap={createdMap}>
                {children}
            </Map>
        </div>
    )
})

const SplitScreen = (props) => {
    const {mode, children, style} = props;

    const mapListRef = useRef([]);


    const addMap = (map) => {
        mapListRef.current.push(map);
        onChange();
    }

    const removeMap = (map) => {
        mapListRef.current = mapListRef.current.filter(item => item !== map);
        onChange();
    }

    const onChange = () => {
        let currentViewer;
        // 同步视角
        const syncViewer = (e) => {
            if (currentViewer && currentViewer?.scene?.id !== e?.id && e._view?.camera) {
                e._view.camera.flyTo({
                    destination: currentViewer.camera.position,
                    orientation: {
                        heading: currentViewer.camera.heading,
                        pitch: currentViewer.camera.pitch,
                        roll: currentViewer.camera.roll
                    },
                    duration: 0.0
                })

            }
        }

        mapListRef.current.map(viewer => {
            viewer.onMouseMove = () => {
                currentViewer = viewer;
            }

            // 先移除监听
            viewer.camera.changed.removeEventListener(syncViewer);
            viewer.scene.preRender.removeEventListener(syncViewer);

            // 再添加监听
            viewer.camera.changed.addEventListener(syncViewer);
            viewer.scene.preRender.addEventListener(syncViewer);
        })
    }

    return (
        <Provider
            value={{
                mode,
                mapList: mapListRef.current,
                addMap,
                removeMap
            }}
        >
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex', flexDirection: mode === "VERTICAL" ? 'column' : 'row',
                    ...style
                }}
            >
                {children}
            </div>
        </Provider>
    )
}

SplitScreen.Item = Item;

export default SplitScreen;
